import { OrderSummaryContextProvider } from 'checkout/containers/OrderSummaryContextProvider'
import { FC } from 'react'
import Panel from 'shared/components/Panel/Panel'
import { CheckoutQA } from 'shared/dataAttributes'
import OrderSummary from './OrderSummary'
import { t } from 'localization'

const TP = 'checkout.components.OrderSummaryPanel.OrderSummaryPanel'

interface IOrderSummaryPanelProps {
  className?: string
}

const OrderSummaryPanel: FC<IOrderSummaryPanelProps> = ({ className }) => (
  <Panel
    title={t(`${TP}.title`, 'order summary')}
    qaAttr={CheckoutQA.OrderSummary}
    className={className}
  >
    <OrderSummaryContextProvider>
      <OrderSummary />
    </OrderSummaryContextProvider>
  </Panel>
)

export default OrderSummaryPanel
